const initialState = {
	user: null,
	loading: false,
	error: null
}

const user = (state = initialState, action) => {
	switch (action.type) {
		case 'RESET_APP':
			return { ...initialState }
		case 'SET_USER':
			return {
				...state,
				user: action.payload.user
			}
		case 'GET_USERS':
			return { ...state, loading: true }
		case 'GET_USER_SUCCESS':
			return {
				...state,
				loading: false,
				user: { ...state.user, ...action.payload }
			}
		case 'GET_USERS_FAIL':
			return {
				...state,
				loading: false,
				error: 'Error while fetching users.'
			}
		default:
			return state
	}
}

export default user
